export enum SpacingInputUnit {
  Em = 'em',
  Rem = 'rem',
  Percent = '%',
  Pixel = 'px',
}
